import styled from 'styled-components';

import {
  Content as ModalContent,
  Header,
  Title,
} from '~/components/Modal/styles';
import grid from '~/styles/grid';

export const Container = styled.div`
  ${ModalContent} {
    max-width: 450px;
  }

  ${Header} {
    text-align: center;
    &:after {
      display: none;
    }
  }

  ${Title} {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: ${grid.lg};
    margin-top: ${grid.sm};
  }
`;
